import "phoenix_html"
import Helpdesk from './helpdesk.js';
import SecretKey from "./secret-key.js"
import Inputs from "./inputs.js"
import SearchDropdown from "./search-dropdown.js";
import MyProfile from "./my-profile.js"
import SuperInspector from "./super-inspector.js"
import LiveView from "./live-view.js"
import ElmActivator from "./elm-activator.js";
import ToggleHidden from "./toggle-hidden.js";
import Common from "./common.js";
import "./inline.js"

window.Helpdesk = Helpdesk;
window.SecretKey = SecretKey;
window.Inputs = Inputs;
window.MyProfile = MyProfile;
window.SuperInspector = SuperInspector;
window.SearchDropdown = SearchDropdown;
window.ToggleHidden = ToggleHidden;

// The elm app is embedded as "timesheet-app" for full timesheet, or "header-only-app" for just the header
const elmDiv = document.querySelector('#timesheet-app') || document.querySelector('#header-only-app');
const inTimesheet = document.querySelector('#timesheet-app') != null

// LiveView Socket
LiveView.setupLiveViewSocket();

// There are also hooks in LiveView to load elm
if (elmDiv) {
  ElmActivator.run(elmDiv, inTimesheet)
}

document.addEventListener("click", (e) => {
  if (!e.target.closest("[data-open-news]")) return;
  const csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");
  const region = Common.getRegionFromUrl();
  fetch("/api/token", { headers: { "x-csrf-token": csrfToken } })
    .then((res) => res.json())
    .then((data) => {
      window.open(`https://news.mitimes.com?token=${data.token}&region=${region}`, "_blank");
    });
});

document.addEventListener("click", (e) => {
  const btn = e.target.closest("[data-copy-value]");
  if (!btn) return;
  navigator.clipboard.writeText(btn.dataset.copyValue);
});
